import styled, {css} from "styled-components";

export const AccordionHeaderDefaultBox = styled.div<{isTitleCentered: boolean}>`
    display: flex;
    width: 100%;
    align-items: center;
    ${props => props.isTitleCentered ? css`
        justify-content: center;
    ` : css`
        justify-content: space-between;
    `}
`;
